import type { TFunction } from 'i18next'

import { CURRICULUM_AIMS } from '../constants/curriculum-aim'

export const getCurriculumAimOptions = (
  t: TFunction<'curriculumsManagement'>
) =>
  CURRICULUM_AIMS.map(aim => ({
    value: aim,
    label: t(`aim.${aim}`)
  }))
